const statusLabels: Record<string, string> = {
  queued: "排队中",
  collecting: "正在收集行情",
  full_running: "正在进行深度判断",
  validating: "正在校验结果",
  no_signal: "已完成（无交易信号）",
  blocked: "已阻断",
  failed: "运行失败",
  expired: "已过期",
  shadow_only: "已完成（仅观察）",
  signal_generated: "已生成交易信号",
  completed: "已完成",
  ready: "就绪",
  not_started: "未启动",
  timeout: "已超时",
  skipped: "已跳过",
  pending: "等待中",
  waiting: "等待账号执行结果",
  connected: "连接已确认",
  processing: "处理中",
  running: "运行中",
  success: "成功",
  hold: "继续观察",
  candidate: "已通过初筛",
  strategy_candidate: "已形成候选",
  strategy_no_candidate: "未形成候选",
  pass: "通过",
  approved: "已通过",
  rejected: "未通过",
  unavailable: "不可用",
  unknown: "结果未知",
  not_invoked: "未调用模型",
};

const reasonLabels: Record<string, string> = {
  PULLBACK_ARMED: "已形成回调准备，尚未出现确认信号，本轮继续观察",
  WAIT_RETEST: "已形成突破形态，正在等待回踩确认",
  STRATEGY_CONFIRMED: "策略形态已确认，已形成交易候选",
  STRATEGY_ANCHOR_INVALID: "策略价格锚点不符合要求，未形成交易候选",
  STRATEGY_INVALIDATED: "原持仓策略依据已失效，需要进一步判断",
  STRATEGY_THESIS_VALID: "原持仓策略依据仍然有效",
  POSITION_REVIEW: "本轮检查已有持仓的策略依据",
  STRATEGY_HISTORY_INSUFFICIENT: "策略所需历史行情不足，尚不能完成检查",
  STRATEGY_VOLATILITY_INVALID: "策略波动率数据无效，尚不能完成检查",
  STRATEGY_POSITION_REFERENCE_INVALID: "持仓策略参考数据无效，尚不能完成检查",
  RULE_SNAPSHOT_HASH_INVALID: "冻结策略规则校验未通过，已停止本轮检查",
  RULE_SNAPSHOT_INVALID: "冻结策略规则无效，已停止本轮检查",
  STRATEGY_RULE_SCOPE_INVALID: "策略规则适用范围不一致，已停止本轮检查",
  STRATEGY_EVALUATION_IDENTITY_INVALID: "策略检查结果身份不一致，已停止本轮检查",
  STRATEGY_BAR_PRICE_INVALID: "策略行情价格无效，尚不能完成检查",
  STRATEGY_BAR_SEQUENCE_INVALID: "策略行情序列不完整，尚不能完成检查",
  STRATEGY_BAR_TIME_INVALID: "策略行情时间无效，尚不能完成检查",
  STRATEGY_CUTOFF_BAR_MISSING: "本轮收盘行情缺失，尚不能完成策略检查",
  STRATEGY_CUTOFF_INVALID: "策略检查截止时间无效",
  STRATEGY_DATA_ROLES_INVALID: "策略行情角色配置不符合要求",

  APPROVED_CONFIG_REQUIRED: "智能体配置尚未审核通过",
  MARKET_SOURCE_PENDING: "行情来源正在自动准备，请稍候",
  EA_JOB_PENDING: "EA 开通任务正在自动创建",
  EA_JOB_FAILED: "EA 开通失败，系统将按任务状态重试或显示具体错误",
  EA_ACTIVATION_PENDING: "账号执行尚未激活，系统正在自动准备",
  EA_CONFIG_MISMATCH: "EA 配置与当前要求不一致，等待重新激活",
  EA_ACCOUNT_IDENTITY_UNVERIFIED: "EA 身份或心跳尚未通过校验",
  UNATTENDED_NOT_VERIFIED: "终端托管服务尚未通过在线校验",
  EA_ACTIVATION_TIMEOUT: "EA 执行激活超时，等待恢复",
  AUTO_EXECUTION_NOT_READY: "账号执行条件未满足，请检查终端状态",
  FOLLOW_CONSENT_INACTIVE: "跟随授权尚未生效或已撤销",
  NEEDS_REAUTHORIZATION: "策略或风险版本已变化，参与账号需重新授权后才能执行新信号",
  ACCOUNT_AUTHORIZATION_REVOKED: "该账号授权已撤销，新下单已阻断；已有仓位仍需单独处理退出",
  ACCOUNT_POLICY_NOT_READY: "该账号执行政策未就绪，不影响其他账号",
  FAST_MARKET_READY: "行情和市场条件已通过初筛，候选结果见策略检查",
  STRATEGY_NO_CANDIDATE: "本轮策略入场条件尚未成立，未调用主决策智能体",
  STRATEGY_TRIGGER_NOT_FORMED: "本轮入场形态尚未形成，未调用主决策智能体",
  STRATEGY_HIGHER_TIMEFRAME_OPPOSED: "本轮入场方向与较长周期走势不一致，未调用主决策智能体",
  STRATEGY_TRENDS_UNCLEAR: "较长周期走势尚不明确，未调用主决策智能体",
  STRATEGY_TREND_CANDIDATE: "策略发现顺势候选，交由主决策智能体判断",
  MTF_INGEST_GATE_CLOSED: "行情采集尚未开放，请联系管理员恢复采集服务",
  MTF_SHADOW_GATE_CLOSED: "服务端策略判断尚未开放",
  MTF_FULL_GATE_CLOSED: "服务端深度判断尚未开放",
  MTF_FULL_PROVIDER_UNAVAILABLE: "深度判断模型尚未配置或未启用",
  MTF_CADENCE_NOT_ENABLED: "当前决策周期尚未在预发环境开放",
  TRADE_AUTHORIZATION_REQUIRED: "请先完成交易审核并激活授权，再开启策略运行",
  TRADE_AUTHORIZATION_STALE: "交易授权与当前配置不一致，请重新审核",
  TRADE_AUTHORIZATION_EXPIRED: "交易授权已过期，请重新提交审核",
  TRADE_AUTHORIZATION_NOT_EFFECTIVE: "尚未到交易授权生效时间",
  MASTER_RUNTIME_DISABLED: "策略已暂停，可在授权有效时重新开启",
  MASTER_REVIEWED_TRADE_DISABLED: "服务端审核交易开关未开放",
  MASTER_SIGNAL_EXECUTION_GATE_CLOSED: "服务端信号执行尚未开放",
  MASTER_EA_COMMAND_GATE_CLOSED: "EA 指令通道尚未开放",
  MTF_DEMO_SIGNAL_GATE_CLOSED: "Demo 信号生成尚未开放",
  MTF_DEMO_AGENT_NOT_ALLOWED: "当前智能体未加入 Demo 白名单",
  MTF_DEMO_CADENCE_NOT_APPROVED: "当前周期或品种未加入 Demo 白名单",
  MASTER_HEARTBEAT_STALE: "EA 心跳已过期，请检查终端连接",
  MASTER_EA_CAPABILITY_DISABLED: "EA 尚未开启下单能力",
  MASTER_TRADE_NOT_ALLOWED: "MT4 自动交易尚未开启",
  MASTER_COMMAND_SCHEMA_UNSUPPORTED: "EA 尚未支持当前交易指令，请更新 EA",
  MASTER_EA_JOURNAL_UNHEALTHY: "EA 执行日志异常，需恢复后再启动",
  MASTER_RISK_CAPACITY_EXCEEDED: "持仓与待执行订单已占满授权额度，请等待执行结果或持仓更新",
  MASTER_RISK_FACTS_MISSING: "账户风控事实不完整，请检查 EA 心跳",

  FAST_HISTORY_GAP: "历史行情数据不足，尚未满足快速判断所需的完整周期",
  SOURCE_SEQUENCE_UNVERIFIED: "行情来源序列尚未核验，本轮暂停判断",
  SOURCE_SEQUENCE_MISMATCH: "行情内容与已认证序列冲突，本轮暂停判断",
  FAST_HISTORY_INSUFFICIENT: "历史行情数据不足，尚未满足快速判断所需的最低数量",
  FAST_HISTORY_STALE: "历史行情已过期，不能用于本次快速判断",
  FAST_QUOTE_UNAVAILABLE: "实时行情不可用，无法完成本次快速判断",
  FAST_CONFIRMATION_NEUTRAL: "确认周期方向中性，尚未形成一致的交易条件",
  FAST_NO_TRIGGER_SETUP: "触发周期尚未形成有效的入场形态",
  FAST_NO_H1_SETUP: "触发周期尚未形成突破或回调延续形态",
  FAST_H4_NEUTRAL: "确认周期趋势中性，暂不进入后续判断",
  FAST_TIMEFRAME_CONFLICT: "多个周期方向冲突，暂不生成交易候选",
  FAST_NO_QUALIFIED_CANDIDATE: "快速判断未找到满足条件的交易候选",
  FAST_SESSION_BLOCKED: "该历史运行按当时的系统规则暂停判断",
  FAST_EVENT_WINDOW: "当前处于高影响事件窗口，暂不生成交易候选",
  FAST_EVENT_DATA_UNAVAILABLE: "高影响事件数据不可用，无法安全完成判断",
  FAST_INSTRUMENT_FACTS_UNVERIFIED: "经纪商品种规格未核验",
  ADMISSION_INSTRUMENT_FACTS_CHANGED: "经纪商品种规格已变化，需要重新决策",
  ADMISSION_PRICE_GRID_INVALID: "建议价格不符合经纪商最小价格步长",
  ADMISSION_INSTRUMENT_FACTS_UNVERIFIED: "经纪商最小价格步长未核验",
  ACCOUNT_PRICE_GRID_INCOMPATIBLE: "此账号价格步长与共享信号不兼容",
  ACCOUNT_INSTRUMENT_FACTS_UNVERIFIED: "此账号品种规格未核验",
  FAST_SPREAD_ABNORMAL: "当前点差超过允许范围",
  FAST_SPREAD_BASELINE_UNAVAILABLE: "点差基准不可用，无法判断当前点差是否正常",
  FAST_VOLATILITY_OUT_OF_RANGE: "当前波动率不在批准范围内",
  FAST_INPUT_HASH_INVALID: "冻结输入校验失败，本次判断不能继续",
  FAST_BROKER_IDENTITY_MISMATCH: "行情来源与绑定的经纪商身份不一致",
  FAST_BAR_ORDER_INVALID: "行情时间顺序异常，无法可靠判断",
  FAST_FUTURE_BAR: "检测到未来时间的行情数据，本次判断已阻断",
  FAST_TRIGGER_MISMATCH: "实际触发周期与当前配置不一致",
  FAST_REQUIRED_EVIDENCE_MISSING: "快速判断缺少必要证据，不能继续",
  FAST_CANDIDATE_STRONG: "多个周期方向一致，已形成强交易候选",
  FAST_CANDIDATE_WEAK: "主要周期方向一致，已形成弱交易候选",
  FAST_HOLD: "快速判断建议继续观察，本次不生成交易候选",
  FULL_TIMEOUT: "深度判断超时，未在限定时间内返回结果",
  FULL_UNAVAILABLE: "深度判断结果不可用，因此后续阶段未启动",
  FULL_NOT_REQUIRED: "本轮策略没有形成可分析的机会，未调用主决策智能体",
  FULL_NOT_TRIGGERED: "本次运行未满足进入深度判断的条件",
  FULL_DISABLED: "深度判断功能当前未启用",
  FULL_HOLD: "深度判断建议继续观察，本次不生成交易信号",
  FULL_PROPOSAL: "深度判断已形成结构化结论，请结合多周期与风险依据核对",
  FOLLOWER_PROJECTION: "跟单指令与执行结果已关联，成交状态以逐笔回报为准",
  FULL_PROVIDER_FAILED: "深度判断服务调用失败",
  FULL_QUEUE_TIMEOUT: "深度判断排队超时，未能开始执行",
  FULL_TOTAL_TIMEOUT: "深度判断整体执行超时",
  FULL_SCHEMA_INVALID: "深度判断返回的数据格式不符合约定",
  FULL_REQUIRED_EVIDENCE_MISSING: "深度判断缺少必要证据，不能继续",
  FULL_LINEAGE_MISMATCH: "深度判断使用的输入链路与本次运行不一致",
  FULL_REQUEST_BUDGET_EXCEEDED: "深度判断调用预算已用完",
  FULL_ATTEMPT_UNKNOWN: "深度判断尝试结果未知，需要人工检查",
  FULL_RESULT_PENDING: "深度判断调用正在进行，等待结果写入",
  FULL_RESULT_RECORDED: "深度判断结果已记录，等待后续校验",
  LLM_ROUTE_UNAVAILABLE: "主模型调用路由不可用，未发起模型调用",
  LLM_FALLBACK_UNAVAILABLE: "未配置可用的备用模型，未发起备用调用",
  MTF_FULL_BUDGET_EXHAUSTED: "本周期深度判断预算已用完，本次运行已阻断",
  ADMISSION_APPROVED: "策略准入校验通过",
  ADMISSION_DIRECTION_CONFLICT: "候选方向与策略允许方向冲突",
  ADMISSION_ALIGNMENT_INVALID: "多周期方向一致性不满足策略要求",
  ADMISSION_EVIDENCE_INVALID: "候选证据不完整或无效",
  ADMISSION_CONFIDENCE_LOW: "判断置信度低于策略阈值",
  ADMISSION_QUOTE_STALE: "用于准入校验的行情已过期",
  ADMISSION_SIGNAL_EXPIRED: "交易信号已超过有效时间",
  ADMISSION_RISK_REWARD_LOW: "预期风险收益比低于策略要求",
  ADMISSION_SL_TP_INVALID: "止损或止盈参数不符合策略约束",
  ADMISSION_ACTION_NOT_ALLOWED: "当前策略不允许执行该交易动作",
  ADMISSION_SYMBOL_MISMATCH: "交易品种与当前策略配置不一致",
  ADMISSION_FACTS_NOT_ELIGIBLE: "当前市场事实不满足策略准入条件",
  ADMISSION_ENTRY_DEVIATION: "建议入场价偏离当前可执行价格超过策略阈值",
  ADMISSION_QUOTE_UNAVAILABLE: "当前报价不可用，已暂停执行",
  ADMISSION_QUOTE_PROVENANCE_MISSING: "报价缺少可核对的 EA 来源证据",
  ADMISSION_QUOTE_SOURCE_MISMATCH: "报价来源与当前主账号或终端不一致",
  ADMISSION_QUOTE_TIME_INVALID: "报价接收时间无效",
  ADMISSION_QUOTE_INVALID: "当前报价数值无效",
  ADMISSION_QUOTE_READ_TIMEOUT: "读取当前报价超时",
  ADMISSION_LIVE_SPREAD_ABNORMAL: "当前点差超过策略允许范围",
  ADMISSION_SPREAD_BASELINE_UNAVAILABLE: "点差基准缺失或已过期",
  ADMISSION_SPREAD_BASELINE_EXPIRED: "点差基准已过期，需要更新后再检查",
  ADMISSION_LIVE_PROTECTION_INVALID: "按当前价格计算的止损或止盈不符合策略要求",
  ADMISSION_LIVE_RISK_REWARD_LOW: "按当前价格计算的风险收益比低于策略要求",
  ADMISSION_CHECK_EXPIRED: "准入检查已过期，需要重新获取行情",
  ADMISSION_POLICY_INVALID: "准入策略或证据链不一致，已阻断执行",
  CADENCE_NATURAL_CLOSE: "已到达自然周期收盘时间，系统按计划触发本次判断",
  INPUT_FROZEN: "本次判断使用的多周期行情输入已冻结",
  NO_SIGNAL: "本次判断已完成，但没有形成交易信号",
  PROPOSAL_HOLD: "主决策智能体建议继续观察，本次不生成交易信号",
  SHADOW_ONLY: "当前为观察模式，只记录判断结果，不产生交易",
  SIGNAL_GENERATED: "本次判断已生成交易信号",
};

const stageLabels: Record<string, string> = {
  trigger_received: "自然周期触发",
  input_frozen: "行情输入准备",
  strategy_check: "策略检查",
  fast_gate: "快速市场检查",
  full_decision: "主决策智能体判断",
  admission: "决策结果准入校验",
  master_signal: "共享信号生成",
  master_execution: "主账号执行",
  master_fill: "平台账号成交",
  follower_handoff: "账号执行关系说明",
  follower_result_summary: "跟随账户执行结果",
};

const fieldLabels: Record<string, string> = {
  status: "当前状态",
  setup_type: "判断类型",
  feature_hash: "特征摘要标识",
  reason_codes: "原因",
  evidence_refs: "证据引用",
  reason_summary: "原因摘要",
  schema_version: "数据版本",
  candidate_strength: "候选强度",
  candidate_direction: "候选方向",
  signal: "信号",
  decision: "判断结论",
  confidence: "置信度",
  threshold: "判断阈值",
  duration_ms: "耗时",
  model_id: "模型标识",
  model_version: "模型版本",
  route_id: "调用路由",
  configured_timeout_ms: "配置超时",
  effective_timeout_ms: "有效超时",
  total_budget_ms: "总时间预算",
  remaining_budget_ms: "调用前剩余预算",
  latency_ms: "调用耗时",
  reserved_at: "尝试预留时间",
  completed_at: "结果记录时间",
  invocation_started: "是否已发起调用",
};

const roleLabels: Record<string, string> = {
  signal: "策略周期",
  trigger: "触发周期",
  confirmation: "确认周期",
  regime: "趋势周期",
};

const directionLabels: Record<string, string> = {
  BUY: "买入",
  SELL: "卖出",
  HOLD: "继续观察",
  LONG: "做多",
  SHORT: "做空",
};

export function statusLabel(value?: string | null): string {
  if (!value) return "暂无状态";
  return statusLabels[value.toLowerCase()] || "未识别状态";
}

export function statusTone(value?: string | null): string {
  const normalized = value?.toLowerCase();
  if (["completed", "ready", "success", "signal_generated", "strategy_candidate"].includes(normalized || "")) return "bg-emerald-500/10 text-emerald-600";
  if (["blocked", "failed", "timeout", "unknown"].includes(normalized || "")) return "bg-red-500/10 text-red-600";
  if (["queued", "collecting", "full_running", "validating", "running", "pending"].includes(normalized || "")) return "bg-blue-500/10 text-blue-600";
  if (["expired", "not_started", "not_invoked", "skipped", "no_signal", "shadow_only", "strategy_no_candidate"].includes(normalized || "")) return "bg-amber-500/10 text-amber-600";
  return "bg-slate-500/10 text-slate-600";
}

export function reasonLabel(value?: string | null): string {
  if (!value) return "暂无异常原因";
  return reasonLabels[value] || "系统返回了尚未配置中文说明的原因，请查看原始码";
}

/** Consume only the reason and matching server summary; never infer a business outcome. */
export function resolveDisplayReason(value?: string | null, explanation?: {reason_code: string | null; summary_zh: string} | null): string {
  if (value && reasonLabels[value]) return reasonLabels[value];
  const summary = explanation?.reason_code === value ? explanation.summary_zh?.trim() : "";
  const generic = ["请查看本轮各阶段的检查结果", "此阶段暂无可读原因，请凭运行编号排查。"];
  if (summary && !generic.includes(summary)) return summary;
  // Expose only bounded symbolic reason codes, never arbitrary backend diagnostic text.
  if (value && /^[A-Z][A-Z0-9_]{0,95}$/.test(value)) return `原因说明尚未配置（原因码：${value}）`;
  return value ? "原因说明尚未配置" : "未记录具体原因";
}

export function stageReasonLabel(value?: string | null): string | null {
  return value ? resolveDisplayReason(value) : null;
}

export function stageLabel(value: string): string {
  return stageLabels[value] || "扩展判断阶段";
}

export function fieldLabel(value: string): string {
  return fieldLabels[value] || "扩展信息";
}

export function roleLabel(value: string): string {
  return roleLabels[value] || value.toUpperCase();
}

function stringValue(value: string): string {
  const normalized = value.toLowerCase();
  if (statusLabels[normalized]) return statusLabels[normalized];
  if (reasonLabels[value]) return reasonLabels[value];
  if (directionLabels[value.toUpperCase()]) return directionLabels[value.toUpperCase()];
  return value;
}

export function displayValue(value: unknown): string {
  if (value === null || value === undefined || value === "") return "暂无 / 未生成";
  if (typeof value === "boolean") return value ? "是" : "否";
  if (typeof value === "string") return stringValue(value);
  if (typeof value === "number") return String(value);
  if (Array.isArray(value)) {
    if (!value.length) return "暂无";
    return value.map((item) => displayValue(item)).join("、");
  }
  if (typeof value === "object") return `包含 ${Object.keys(value as Record<string, unknown>).length} 项结构化数据`;
  return String(value);
}

export function formatRunTime(value: number): string {
  return new Date(value * 1000).toLocaleString("zh-CN", { hour12: false });
}

export function reasonCodeHint(value?: string | null): string | null {
  return value ? `原始码：${value}` : null;
}
